import Navbar from "../../../components/navbar/navbar";
import Partners from "../../../components/partners/partners";
import Pronouncement from "../../../components/pronouncement/pronouncement";
import {
  ContainerCard,
  Container,
  GridContainer,
  CardImage,
  ContentCard,
  CardTitle,
  Content,
  Datecard,
  Description,
} from "./style";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Footer from "../../../components/footer/footer";
import Sliders from "../../../components/slider/slider";
import Flys from "../../../components/flys/flys";
import { useTranslation } from "react-i18next";
import { AppProperty } from "../../../models/Property";
import { storageServerPath } from "../../../utils/server/api";
import { useAuth } from "../../../context/AuthContext";
import { useServiceProperty } from "../../../hooks/serviceProperty";
import MoreCard from "../../../components/more-card/more-card";
import { useServiceHome } from "../../../hooks/serviceHome";
import MoreCardCatalog from "../../../components/more-card-catalog/more-card-catalog";
import { useServiceShoppingCart } from "@/hooks/serviceShoppingCart";
import HowItWorksSections from "@/components/howitworks/HowItWorksSections";

const HomeBuy: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getHome } = useServiceHome();
  const { setPropertyVisits } = useServiceProperty()
  const { user } = useAuth();
  const token = localStorage.getItem("token");
  const typeUser = localStorage.getItem("userType");
  const { getArea, openGetArea, getCatalog } = useServiceProperty();
  const { getDollarQuotation } = useServiceShoppingCart();
  const [quotation, setQuotation] = useState(0);
  const [imagePaths, setImagePaths] = useState<{
    carousel: { id: number; image_path: string }[];
    advert: {
      id: number;
      company_name: string;
      description: string;
      image: string;
      url: string;
      status: string;
    }[];
    pronouncement: {
      id: number;
      title: string;
      link: string;
      image: string;
      created_at: string;
      title_en?: string | "";
    }[];
  }>({ carousel: [], advert: [], pronouncement: [] });
  const [isLoading, setIsLoading] = useState<Boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    getHome()
      .then((response) => {
        setImagePaths(response);
      })
      .catch((error) => {
        console.error(error);
      });

    if (!token) {
      navigate("/choice");
      return;
    } else {
      if (typeUser === "engineer") {
        getArea().then((data) => {
          setProperties(data);
        });
      } else {
        openGetArea().then((data) => {
          setProperties(data);
        });
      }

      getDollarQuotation().then((data) =>
        setQuotation(Number(data.USDBRL.bid) * 10)
      );

      getCatalog().then((data) => {
        setCatalogs(data);
      });
    }
    setIsLoading(false);
  }, []);

  const [properties, setProperties] = useState<AppProperty[]>([]);
  const [catalogs, setCatalogs] = useState<AppProperty[]>([]);
  const lng = localStorage.getItem("language");

  return (
    <div className="flex flex-col items-center">
      <Sliders images={imagePaths?.carousel} />
      <Flys />
      <HowItWorksSections />

      {isLoading === true ? (
        <div className="!w-24 !h-24 !border-8 !border-blue-500 !border-t-transparent !rounded-full animate-spin mt-12 mb-12" />
      ) : properties.length == 0 ? (
        <div className="flex w-full items-center justify-center">
          <p className="!font-[poppins] font-bold !text-3xl p-10">
            Sem propriedades no catálogo
          </p>
        </div>
      ) : (
        <Content>
          <h1 className="!text-[#356405] self-start !m-10 !text-4xl !font-bold">{t("All properties")}</h1>
          <div className="grid grid-cols-4 gap-10">
            {properties.slice(0, 9).map((p, i) => {
              let rounded = "rounded-br-[50px] rounded-tl-[50px]";
              let bg = "bg-white";
              let text = {
                textTitle: "!text-[#50700F]",
                textP: "!text-black",
              };
              let button =
                "w-full rounded-md !py-3 !text-white font-medium !text-lg !bg-[#50700F]";

              if (i % 2 != 0) {
                rounded = "rounded-bl-[50px] rounded-tr-[50px]";
                bg = "bg-[#356405]";
                text = {
                  textTitle: "!text-white",
                  textP: "!text-white",
                };
                button =
                  "w-full rounded-md !py-3 !text-[#50700F] font-medium !text-lg !bg-white";
              }

              return (
                <div
                  className={`flex flex-col justify-end w-full float-left ${bg} ${text.textP} !border-1 !border-[#50700F] ${rounded} w-full h-auto mb-10 shadow-lg
                    max-[769px]:max-w-full
                    max-[769px]:h-auto
                    hover:scale-105 transition-all duration-300
                  `}
                  key={i}
                >
                  <Datecard>
                    <CardImage
                      src={storageServerPath + p?.file_images?.split(";")[0]}
                    />

                    <ContentCard>
                      <h3
                        className={`!text-[22px] w-full ${text.textTitle} whitespace-normal !mb-5`}
                      >
                        {/* {lng === "en"
                        ? (p.name_en || "").slice(0, 57)
                        : p.name.slice(0, 57)} */}
                        {p.name.slice(0, 57)}
                      </h3>

                      <Description className="!whitespace-pre-line">
                        {`
                      ${t("credits_available")}: ${
                          p.carbon_credits_available
                        } tCO₂
                      ${t("estimated_value")}: ${(
                          quotation * p.carbon_credits_available
                        ).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      ${t("tons_estimated_value")}: R$${quotation.toFixed(2)}
                      `}
                        {/* {lng === "en"
                        ? (p.description_en || "").slice(0, 80)
                        : (p.description || "").slice(0, 80)} 
                      ...
                        */}
                      </Description>
                      <button
                        onClick={async () => {
                          if (p.user_id !== user?.id) {
                            await setPropertyVisits(p.id, user?.id!)
                          }
                          navigate(`/detailsPropertySeller/${p.id as number}`)}
                        }
                        className={`${button} cursor-pointer`}
                      >
                        Acessar Propriedade
                      </button>
                    </ContentCard>
                  </Datecard>
                </div>
              );
            })}
          </div>
          <MoreCard />
        </Content>
      )}
      <Partners data={imagePaths?.advert} />
      {isLoading === true ? (
        <div className="!w-24 !h-24 !border-8 !border-blue-500 !border-t-transparent !rounded-full animate-spin mt-12 mb-12" />
      ) : catalogs.length == 0 ? (
        <div className="flex w-full items-center justify-center">
          <p className="!font-[poppins] font-bold !text-3xl p-10">
            Sem propriedades no catálogo
          </p>
        </div>
      ) : (
        <Content>
            <h1 className="!text-[#356405] self-start !m-10 !text-4xl !font-bold">{t("catalog")}</h1>
          <div className="w-full grid grid-cols-4 gap-10">
            {catalogs.slice(0, 9).map((p, i) => {
              let rounded = "rounded-br-[50px] rounded-tl-[50px]";
              let bg = "bg-white";
              let text = {
                textTitle: "!text-[#50700F]",
                textP: "!text-black",
              };
              let button =
                "w-full rounded-md !py-3 !text-white font-medium !text-lg !bg-[#50700F]";

              if (i % 2 != 0) {
                rounded = "rounded-bl-[50px] rounded-tr-[50px]";
                bg = "bg-[#356405]";
                text = {
                  textTitle: "!text-white",
                  textP: "!text-white",
                };
                button =
                  "w-full rounded-md !py-3 !text-[#50700F] font-medium !text-lg !bg-white";
              }

              return (
                <div
                  className={`flex flex-col justify-end w-full float-left ${bg} ${text.textP} !border-1 !border-[#50700F] ${rounded} w-full h-auto mb-10 shadow-lg
                    max-[769px]:max-w-full
                    max-[769px]:h-auto
                    hover:scale-105 transition-all duration-300
                  `}
                  key={i}
                >
                  <Datecard>
                    <CardImage
                      src={storageServerPath + p?.file_images?.split(";")[0]}
                    />

                    <ContentCard>
                      <h3
                        className={`!text-[22px] w-full ${text.textTitle} whitespace-normal !mb-5`}
                      >
                        {/* {lng === "en"
                      ? (p.name_en || "").slice(0, 57)
                      : p.name.slice(0, 57)} */}
                        {p.name.slice(0, 57)}
                      </h3>

                      <Description className="!whitespace-pre-line">
                        {`
                      ${t("credits_available")}: ${
                          p.carbon_credits_available
                        } tCO₂
                      ${t("estimated_value")}: R$${(
                          quotation * p.carbon_credits_available
                        ).toFixed(2)}
                      ${t("tons_estimated_value")}: R$${quotation.toFixed(2)}
                      `}
                        {/* {lng === "en"
                        ? (p.description_en || "").slice(0, 80)
                        : (p.description || "").slice(0, 80)} 
                      ...
                        */}
                      </Description>

                      <button
                        onClick={() =>
                          navigate(`/detailsPropertySeller/${p.id as number}`)
                        }
                        className={`${button} cursor-pointer`}
                      >
                        Acessar Propriedade
                      </button>
                    </ContentCard>
                  </Datecard>
                </div>
              );
            })}
          </div>
          <MoreCardCatalog />
        </Content>
      )}
      <Pronouncement data={imagePaths?.pronouncement} />
      <Footer />
    </div>
  );
};

export default HomeBuy;
